import Debug from 'debug';
import { customElement, property } from 'lit/decorators.js';
import { html, LitElement, PropertyValues } from 'lit';
import { dataBroker } from '../services/DataBroker';
import { PaginationConfig, PaginationPage } from '../flow/pdq-pagination';

import "@carbon/web-components/es/components/pagination/index.js"
import '@carbon/web-components/es/components/pagination/index.js';
import CDSPagination from '@carbon/web-components/es/components/pagination/pagination.js';

const log = Debug('pdq:ui:pdq-pager');

@customElement('pdq-pager-internal')
export class PdqPagerInternal extends CDSPagination {


}
@customElement('pdq-pager')
export class PdqPager extends LitElement {
  private _page = 1
  private _pageSize = 10
  private _source = ''
  private _sourcePage: PaginationPage<any>
  private _cleanup = () => {}


  @property({type: String})
  get source () {
    return this._source
  }
  set source(value: string) {
    if (value)
    this._cleanup()
    this._source = value
    log('set source')
    dataBroker.getObservableDataSource(this.source).then(s => {
      log('get source config subscribable')
      const sub = s.subscribe((pageConfig: PaginationPage) => {
        log('get source config', pageConfig)
        this._sourcePage = pageConfig
        if (!this.isUpdatePending)
          this.requestUpdate()
      })
      this._cleanup = () => sub.unsubscribe()
    })
  }

  @property({type:Array, attribute: "page-sizes"})
  pageSizes = [10, 25, 100]

  @property({type:Number, reflect: true})
  get page(): number {
    return this._page;
  }
  set page(value: number) {
    log('set page')
    this._page = value;
    this.setSourceConfig()
  }

  @property({type:Number, reflect: true})
  get pageSize() {
    return this._pageSize
  }
  set pageSize(value: number) {
    log('set pageSize')
    this._pageSize = value
    this.setSourceConfig()
  }

  private setSourceConfig(){
    if (!this._sourcePage)
      return
    log(`setting page config`)
    const ds = {...dataBroker.getDataSource(`${this.source}__page_config`)}
    if (ds) {
      ds.page = this._page
      ds.pageSize = this._pageSize
      dataBroker.setDataSource(`${this.source}__page_config`, ds)//.then(this.requestUpdate as any)
    }
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    log('firstUpdated')
  }

  render(){
    if (!this._sourcePage)
      return html`Waiting for pagination to come online...`
    return html`
      <cds-pagination page="${this._sourcePage.page}" page-size=${this._sourcePage.pageSize}
                      total-items=${this._sourcePage.totalItems}
                      @cds-pagination-changed-current=${this.changePage}
                      @cds-page-sizes-select-changed=${this.changePageSize}
      >
        ${this.pageSizes.map(i => html`
          <cds-select-item value="${i}">${i}</cds-select-item>`)}
      </cds-pagination>
    `
  }

  changePage(evt: {detail: {page: number, pageSize: number}}){
    log(evt)
    this._page = evt.detail.page
    this._pageSize = evt.detail.pageSize
    this.setSourceConfig()
  }
  changePageSize(evt: {detail: {page: number, pageSize: number}}){
    log(evt)
    this._page = evt.detail.page
    this._pageSize = evt.detail.pageSize
    this.setSourceConfig()
  }
}